import { create } from "lodash";
import Swal from "sweetalert2";

export const vsprompt_view = () => ({
    vsprompts: [],
    selectedVsprompt: null,
    filters: {

    },
    pagination: {
        current_page: 1,
        total: 0,
        last_page: 0,
        get previous_page() {
            return this.current_page > 1 ? this.current_page - 1 : 1;
        },
        get next_page() {
            return this.current_page < this.last_page ? this.current_page + 1 : this.last_page;
        },
    },
    // -----------------------------------
    components: {
        form: form(),
        vspromptParam,
        vspromptResponseParam
    },

    get isEditing() {
        return this.components.form.formBody['id'] !== null;
    },

    init(){
        this.getList(this.pagination.current_page);
    },

    async getList(page){
        $('#global-loader').loader('show');
        const filters = Object.keys(this.filters).reduce((acc, key) => {
            if (this.filters[key] !== '' && this.filters[key] !== null) {
                acc[key] = this.filters[key];
            }
            return acc;
        }, {});

        try {
            const { data } = await axios.get('/vs-prompts/getList', {
                params: { page, order: 'desc', ...filters }
            });

            const { vs_prompts, meta: { current_page, last_page, total } } = data;

            this.vsprompts = vs_prompts.map(vsprompt);
            this.pagination = { ...this.pagination, current_page, last_page, total };

        } catch (error) {
            console.error(error);
        } finally {
            $('#global-loader').loader('hide');
        }
    }
});

function form() {
    return({
        body: {
            id          : null,
            assistant_id: null,
            name        : '',
            description : '',
            file        : null,
            file_name   : '',
            file_url    : '',
            type        : 'generico',
            use_scraper : false
        },
        vsprompt: {
            params  : [],
            data    : [],
            response: [],
            prompt  : ''
        },

        // Aux variables ---------------------
        isSaving     : false,
        isDeleting   : false,
        buildVSPrompt: false,

        init(){
            this.$watch('selectedVsprompt', value => {
                this.formBody = value;
                this.formVSPrompt = value?.vsprompt;
            });
        },

        /**
         * Sets the body property with new values.
         * It updates only the properties that have changed.
         *
         * @param {Object} newValues - An object containing the new values to update the body with.
         */
        set formBody(newValues) {
            const updatedBody = { ...this.body };
            for (let key in newValues) {
                Object.keys(this.body).includes(key) && (updatedBody[key] = newValues[key]);
            }

            this.body = updatedBody;
        },

        get formBody() {
            return { ...this.body };
        },

        set formVSPrompt(newValues) {
            const updatedVSPrompt = { ...this.vsprompt };

            for (let key in newValues) {
                switch (key) {
                    case 'params':
                        const params = newValues[key];
                        for (const key in params) {
                            if (Object.prototype.hasOwnProperty.call(params, key)) {
                                const param = params[key];
                                const newParam = vspromptParam();
                                newParam.paramData = { name: key, value: param };
                                updatedVSPrompt.params.push(newParam);
                            }
                        }
                        break;

                    case 'data':
                        if(!newValues.data) continue;

                        updatedVSPrompt.data = newValues.data;
                        this.$dispatch('dual-list-box:set-selected-items', { name: 'vsprompt-data', items: Object.keys(updatedVSPrompt.data) });
                        break;

                    case 'response':
                        const responseParams = newValues[key];
                        if (responseParams.length === 0) continue;
                        for (const key in responseParams) {
                            if(key === 'errors') continue;

                            if (Object.prototype.hasOwnProperty.call(responseParams, key)) {
                                const param = responseParams[key];
                                const newParam = vspromptResponseParam();
                                newParam.paramData = { name: key, value: param };
                                updatedVSPrompt.response.push(newParam);
                            }
                        }
                        break;

                    case 'prompt':
                        updatedVSPrompt.prompt = newValues.prompt;
                        break;

                    default:
                        break;
                }
            }

            this.vsprompt = updatedVSPrompt;
        },

        handleSubmit(action){
            const { id, ...body } = this.body;

            const formData = new FormData();
            for (const key in body) {
                if (!body[key]) continue;
                formData.append(key, body[key]);
            }

            if (this.buildVSPrompt){
                this.vsprompt.params.forEach((param) => {
                    const {name, value } = param.paramData;
                    formData.append(`vsprompt[params][${name}]`, value);
                });

                // Data for vsprompt
                for (const dataKeys in this.vsprompt.data) {
                    if (Object.prototype.hasOwnProperty.call(this.vsprompt.data, dataKeys)) {
                        const element = this.vsprompt.data[dataKeys];

                        if (Object.keys(element).length > 0) {
                            for (const filter in element) {
                                if (Object.prototype.hasOwnProperty.call(element, filter)) {
                                    const filterValue = element[filter];
                                    formData.append(`vsprompt[data][${dataKeys}][${filter}]`, filterValue);
                                }
                            }
                        } else {
                            formData.append(`vsprompt[data][${dataKeys}]`, []);
                        }
                    }
                }

                this.vsprompt.response.forEach((param) => {
                    const { name, value } = param.paramData;
                    formData.append(`vsprompt[response][${name}]`, value);
                });

                formData.append('vsprompt[prompt]', this.vsprompt.prompt);
            }

            if (action === 'create') {
                this.createVSPrompt(formData);
            } else {
                formData.append('_method', 'PUT');
                this.updateVSPrompt(id, formData);
            }
        },

        async createVSPrompt(formData){
            const { isConfirmed } = await Swal.fire({
                title: 'Crear vs prompt',
                text: 'Esto creará un nuevo vs prompt que será sincronizado con OpenAI y estará disponible para ser usado en la plataforma.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Crear',
                cancelButtonText: 'Cancelar'
            });

            if (!isConfirmed) return;

            this.isSaving = true;

            try {
                const { data: { vs_prompt } } = await axios.post('/vs-prompts', formData);

                this.vsprompts.unshift(vsprompt(vs_prompt));

                this.$dispatch('add-toast', {
                    type: 'success',
                    title: 'Se ha creado el vs prompt',
                });

                this.$dispatch('close-drawer', 'editor-vsprompt');

                this.cleanForm();
            } catch (error) {
                console.error(error);

                let message;
                if(error.response){
                    this.handleErrorResponse(error.response);
                    return;
                } else {
                    message = error.message;
                }

                this.$dispatch('add-toast', {
                    type: 'error',
                    title: 'Error al crear vs prompt',
                    message: `<strong>Unespected error</strong>: No se pudo crear el vs prompt.<br>Revisa la consola para más detalles.`
                });

            } finally {
                this.isSaving = false;
            }
        },

        async updateVSPrompt(vspromptID, formData){
            if (!vspromptID) return;

            const { isConfirmed } = await Swal.fire({
                title: 'Actualizar vs prompt',
                text: 'Esto actualizará el vs prompt seleccionado y será sincronizado con OpenAI.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Actualizar',
                cancelButtonText: 'Cancelar'
            });

            if (!isConfirmed) return;

            this.isSaving = true;
            try {
                const { data: { vs_prompt } } = await axios.post(`/vs-prompts/${vspromptID}`, formData);
                const index = this.vsprompts.findIndex(vs => vs.data.id === vs_prompt.id);
                this.vsprompts.splice(index, 1, vs_prompt);

                this.cleanForm();

                this.$dispatch('add-toast', {
                    type: 'success',
                    title: 'Se ha actualizado el vs prompt',
                });

                this.$dispatch('close-drawer', 'editor-vsprompt');

            } catch (error) {
                console.error(error);

                let message;
                if (error.response) {
                    this.handleErrorResponse(error.response);
                    return;
                } else {
                    message = error.message;
                }

                this.$dispatch('add-toast', {
                    type: 'error',
                    title: 'Error al editar vs prompt',
                    message: `<strong>Unespected error</strong>: No se pudo crear el vs prompt.<br>Revisa la consola para más detalles.`
                });
            } finally {
                this.isSaving = false;
            }
        },

        cleanForm(){;
            this.$el.reset();

            this.$nextTick(() => {
                this.body = {
                    id          : null,
                    assistant_id: null,
                    name        : '',
                    description : '',
                    file        : null,
                    file_name   : '',
                    type        : 'generico',
                    use_scraper : false
                };

                this.vsprompt = {
                    params  : [],
                    data    : [],
                    response: [],
                    prompt  : ''
                }

                this.isSaving      = false;
                this.buildVSPrompt = false;

                this.$dispatch('dual-list-box:set-selected-items', { name: 'vsprompt-data', items: [] });
            });
        },

        handleErrorResponse({ data, status, statusText }){
            let message;

            if (status === 400) {
                let errors = '<ul class="list-disc">'
                for (const error in data.errors) {
                    errors += `<li>${data.errors[error][0]}</li>`;
                }
                errors += '</ul>';
                message = `<strong>${statusText}</strong>. Por favor, corrija los errores en el formulario:<br>${errors}`;
            } else {
                message = data.message;
            }

            this.$dispatch('add-toast', {
                type: 'error',
                title: `Error ${this.body.id ? 'editar' : 'crear'} al crear vs prompt`,
                message
            });
        }
    });
}

function vsprompt(prompt) {
    const {
        id,
        assistant_id,
        name,
        description,
        file_url,
        vs_filename,
        synced_status,
        data_sync,
        type,
        use_scraper,
        is_active
    } = prompt;

    const data = {
        id,
        assistant_id,
        name,
        description,
        file_url,
        vs_filename,
        synced_status,
        type,
        use_scraper,
        is_active,
        vsprompt: {
            params: [],
            data: data_sync,
            response: [],
            prompt: ''
        }
    };

    return ({
        data,
        isSyncing: false,

        init(){

        },

        get dataSyncTypes(){
            return Object.keys(this.data.vsprompt.data);
        },

        async syncVSPrompt() {
            const id = this.data.id
            if (!id) return;

            this.isSyncing = true;
            try {
                const { data: { vs_prompt } } = await axios.post(`/vs-prompts/${id}/sync`);
                // const index = this.vsprompts.findIndex(vs => vs.data.id === vs_prompt.id);
                this.data.synced_status = vs_prompt.synced_status;
                this.data.file_url      = vs_prompt.file_url;

                this.$dispatch('add-toast', {
                    type: 'success',
                    title: 'Se ha sincronizado correctamente el vs prompt con OpenAI',
                });
            } catch (error) {
                console.error(error);
                this.$dispatch('add-toast', {
                    type: 'error',
                    title: 'Error al sincronizar vs prompt',
                    message: `<strong>Unespected error</strong>: No se pudo sincronizar el vs prompt.<br>Revisa la consola para más detalles.`
                });
            } finally {
                this.isSyncing = false;
            }
        },

        async deleteVSPrompt() {
            const id = this.data.id

            if (!id) return;

            const { isConfirmed } = await Swal.fire({
                title: 'Eliminar vs prompt',
                text: 'Esto eliminará el vs prompt seleccionado y no podrá ser recuperado.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar'
            });

            if (!isConfirmed) return;

            this.isDeleting = true;

            try {
                await axios.delete(`/vs-prompts/${id}`);
                this.vsprompts = this.vsprompts.filter(vs => vs.data.id !== id);

                this.$dispatch('add-toast', {
                    type: 'success',
                    title: 'Se ha eliminado el vs prompt',
                });

            } catch (error) {
                console.error(error);
                this.$dispatch('add-toast', {
                    type: 'error',
                    title: 'Error al eliminar vs prompt',
                    message: `<strong>Unespected error</strong>: No se pudo eliminar el vs prompt.<br>Revisa la consola para más detalles.`
                });
            } finally {
                this.isDeleting = false;
            }
        },

        async toggleActive(){
            const id = this.data.id;
            if (!id) return;

            try {
                const { data: { vs_prompt } } = await axios.put(`/vs-prompts/${id}/toggle-active`);
                this.data.is_active = vs_prompt.is_active;

                this.$dispatch('add-toast', {
                    type: 'success',
                    title: `Se ha actualizado el estado del vs prompt`,
                    message: `Estado <strong class="italic">${vs_prompt.is_active ? 'activo' : 'pausado'}</strong>`
                });

            } catch (error) {
                console.error(error);
                this.$dispatch('add-toast', {
                    type: 'error',
                    title: 'Error al actualizar el estado del vs prompt',
                    message: `<strong>Unespected error</strong>: No se pudo actualizar el estado del vs prompt.<br>Revisa la consola para más detalles.`
                });
            }
        },

        async setSelectedVSPrompt() {
            try {
                if(!this.data.vsprompt.prompt){
                    const { data: { params, prompt, response } } = await axios.get(file_url);
                    this.data.vsprompt.params   = params;
                    this.data.vsprompt.prompt   = prompt;
                    this.data.vsprompt.response = response;
                }

                this.selectedVsprompt = { ...this.data };
            } catch (error) {
                console.error(error);
            }
        }
    });
}

function vspromptParam(){
    const data = {
        name: '',
        value: ''
    };

    const dataKeys = Object.keys(data);

    return({
        data,
        isRequired: false,

        set paramData(value){
            for (const key in value) {
                if (!dataKeys.includes(key)) delete value[key];

                if (key === 'value' && value[key] === '_required_') {
                    this.isRequired = true;
                    value[key] = '';
                }
            }

            this.data = { ...this.data, ...value };
        },

        get paramData(){
            return { ...this.data, ...(this.isRequired && { value: '_required_' }) };
        }
    });
}

function vspromptResponseParam() {
    const data = {
        name: '',
        value: ''
    };

    const dataKeys = Object.keys(data);

    return ({
        data,
        isRequired: false,

        set paramData(value) {
            for (const key in value) {
                if (!dataKeys.includes(key)) {
                    delete value[key]
                }
            }

            this.data = { ...this.data, ...value };
        },

        get paramData() {
            return { ...this.data, };
        }
    });
}
